import { Order } from './order';
import { DateRange } from '@mui/lab';
import { Organization } from './organization';
import { NShiftShipmentWaybill } from './nshift-shipment-waybill';

export type TransportProvider = {
    externalId?: string;
    code?: string;
    channel: TransportChannel;
};

export enum TransportChannel {
    OPTER = 'OPTER',
    DENTHUB_TRANSPORT = 'DENTHUB_TRANSPORT',
    NSHIFT = 'NSHIFT',
}

export type TransportLocation = {
    organizationId: string;
    name: string;
    streetAddress: string;
    zipCode: string;
    city: string;
    countryCode?: string;
    deliveryInstructions?: string;
    phoneNumber?: string;
    emailAddress?: string;
};

export type TransportOrder = {
    _id?: string;
    lab: string | Organization;
    clinic: string | Organization;
    orderIds: string[];
    orders: Order[];
    serviceCode: TransportServices;
    status: TransportStatus;
    transportDate: Date;
    deadline: string;
    manualPackageCount: number;
    actualPackageCount?: number;
    totalPackageCount: number;
    comment?: string;
    sendersInstruction?: string;
    pickup: TransportLocation;
    delivery: TransportLocation;
    externalId: string;
    internalMessage?: string;
    transportProvider: TransportProvider;
    hasProblem: boolean;
    externalReference?: string;
    dentistName: string;
    isSameDayDelivery?: boolean;
};

export enum TransportStatus {
    PLANNED = 'PLANNED',
    PRINTED = 'PRINTED',
    PICKED_UP = 'PICKED_UP',
    DELIVERED = 'DELIVERED',
    MISSED = 'MISSED',
    REVOKED = 'REVOKED',
}

export enum TransportServices {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY',
}

export type TransportOrderFilter = {
    date?: Date;
    labId?: string;
    hasProblem?: boolean;
};

export enum TransportOnDate {
    NO_DATE_FILTER = 'NO_DATE_FILTER',
    TRANSPORT_CREATED_DATE = 'TRANSPORT_CREATED_DATE',
    TRANSPORT_PICKUP_DATE = 'TRANSPORT_PICKUP_DATE',
    TRANSPORT_DELIVERY_DATE = 'TRANSPORT_DELIVERY_DATE',
}

export type TransportFilter = {
    search?: string;
    searchExternalReference?: string;
    status?: string[];
    labId?: string;
    dateFilterType?: string;
    dateFromTo?: DateRange<Date | null>;
};

export type OpterLogRow = {
    DateAndTime: string;
    Status: string;
    POD_Descr: string;
    DEA_FileName: string;
    DEA_Guid: string;
    DateTimeString: string;
    OFF_Id: number;
    hasImage: boolean;
};

export type TransportOrderRequest = {
    lab: Organization | null;
    clinic: Organization | null;
    date: Date | null;
    serviceCode: TransportServices;
    manualPackageCount: number;
    comment?: string;
    internalMessage?: string;
    deadline: string | null;
};

export type TransportForOrderRequest = {
    transportOrderId?: string;
    clinic: string;
    pickup?: Organization;
    delivery?: Organization;
    comment?: string;
    internalMessage?: string;
    orderId: string;
    manualPackageCount: number;
    transportDay: string;
    dentistName: string;
    serviceCode: TransportServices;
};

export type ClinicDeliveryOrders = {
    _id: string;
    clinic: Organization;
    transportProvider: TransportProvider;
    orders: Order[];
};
export type TransportLine = {
    _id: string;
    name: string;
    transportProviderName: string;
    clinic?: Organization;
    lab: Organization;
    transportOrders?: TransportOrder[];
    waybills?: NShiftShipmentWaybill[];
    transportDate?: Date;
    isDeleted?: boolean;
    fee: Fee[];
};

export type Fee = {
    name: string;
    value: number;
};

export type WaybillPackageSize = {
    _id?: string;
    name: string;
    width: number;
    height: number;
    length: number;
};
